import { timestamps, uuid } from '@snap-types/models/common';
import { z } from 'zod/v4';

export const columns = {
  uuid: uuid,

  teamCode: z.string(),
  teamName: z.string(),

  siteUuid: uuid,
  currentTeamConfigUuid: uuid.nullish(),

  ...timestamps,
};
